export default __webpack_public_path__ + "baebdb11afccd587197f1e48d4e71dbf.png";